import reducer, { InferenceResultObsrecState } from "./reducers";
import * as inferenceResultObsrecOperations from "./operations";
export {
  inferenceResultObsrecOperations,
  InferenceResultObsrecState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/inferenceObsrec/index.ts